import axiosWithAuth from '../utils/axiosWithAuth';

/**
 * Kullanıcının tüm breakdown'larını getirir
 * @returns {Promise<Object>} - Breakdown verileri
 */
export const getAllBreakdowns = async () => {
  try {
    const api = axiosWithAuth();
    // Doğru endpoint - tüm kullanıcı breakdownlarını getiren endpoint
    const response = await api.get('/repairs/breakdowns');
    return response.data;
  } catch (error) {
    console.error('Error fetching all breakdowns:', error);
    throw error;
  }
};

/**
 * Belirli bir breakdown'ın detaylarını getirir
 * @param {string} breakdownId - Breakdown ID
 * @returns {Promise<Object>} - Breakdown detay verileri
 */
export const getBreakdownDetails = async (breakdownId) => {
  try {
    const api = axiosWithAuth();
    const response = await api.get(`/repairs/breakdown/${breakdownId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching breakdown details:', error);
    throw error;
  }
};

/**
 * Belirli bir breakdown'ın malzeme detaylarını getirir
 * @param {string} breakdownId - Breakdown ID
 * @returns {Promise<Object>} - Breakdown malzeme verileri
 */
export const getBreakdownMaterials = async (breakdownId) => {
  try {
    // Handle temporary IDs
    if (breakdownId.startsWith('temp-')) {
      // Get data from localStorage
      const tempData = localStorage.getItem(`breakdown_${breakdownId}`);
      if (!tempData) {
        throw new Error('Temporary breakdown data not found');
      }
      return JSON.parse(tempData);
    }

    // For non-temporary IDs, make API call
    const api = axiosWithAuth();
    const response = await api.get(`/repairs/breakdown-materials/${breakdownId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching breakdown materials:', error);
    throw error;
  }
};

/**
 * Belirli bir mülke ait tüm breakdown'ları getirir
 * @param {string} propertyId - Mülk ID
 * @returns {Promise<Array>} - Mülke ait breakdown'lar
 */
export const getPropertyBreakdowns = async (propertyId) => {
  try {
    const api = axiosWithAuth();
    const response = await api.get(`/repairs/property-breakdowns/${propertyId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching property breakdowns:', error);
    throw error;
  }
};

const breakdownService = {
  getAllBreakdowns,
  getBreakdownDetails,
  getBreakdownMaterials,
  getPropertyBreakdowns
};

export default breakdownService;